// 
// -----------------------------------------------------------------------------
(function ($searchBtn) {
	if ($searchBtn.length === 0) {return false;}

	var $search = $('.search');
	var $searchBtnClose = $('.search-button-close');

	$searchBtn.on('click', function(){
		$search.addClass('on');
	});

	$searchBtnClose.on('click', function(){
		$search.removeClass('on');
	});

})($( '.h-search-button' ));